<template>
    <div class="blog-view-container" v-loading="isLoading" ref="container">
        <div class="blogplate" v-for="item in bloglist.rows" :key="item.id">
            <div class="imgcontent" v-if="item.thumb"><router-link :to="{
                name: 'BlogDetail', params: {
                    id: item.id
                }
            }" class="blog-img-link"><img class="blog-img" alt="" v-lazy="item.thumb"></router-link>
            </div>
            <div class="blogcontent">
                <div class="title">
                    <router-link class="titlelink" :to="{
                        name: 'BlogDetail',
                        params: {
                            id: item.id,
                        }
                    }">{{ item.title }}</router-link>
                </div>
                <div class="label">
                    <span>日期:{{ timestampToDateTime(item.createDate) }}</span>
                    <span>浏览:{{ item.scanNumber }}</span>
                    <span>评论:{{ item.commentNumber }}</span>
                    <router-link :to="{
                        name: 'BlogCategory', params: {
                            categoryId: item.category.id
                        }
                    }" class="label-category">{{ item.category.name }}</router-link>
                </div>
                <div class="des">{{ item.description }}</div>
            </div>
        </div>
        <div class="blog-page">
            <Page :current="routeInfo.CurPage" :limit="routeInfo.CurLimit" :total="total" @pageChange="handlePageChange">
            </Page>
        </div>
        <Empty v-if="bloglist.length === 0 && !isLoading"></Empty>
    </div>
</template>

<script>
import Page from '../../../components/Page';
import { getPageBlogs } from '.././../../api/banner';
import eventBus from '@/eventBus';
import Empty from '@/components/Empty';
export default {
    data() {
        return {
            bloglist: {},
            total: 0,
            isLoading: true,
        }
    },
    components: {
        Page,
        Empty
    },
    computed: {
        routeInfo() {
            const categoryId = + this.$route.params.categoryId || -1;
            const CurPage = +this.$route.query.page || 1;
            const CurLimit = +this.$route.query.limit || 10;
            return {
                categoryId,
                CurPage,
                CurLimit
            }
        },
    },
    watch: {
        $route(newVal) {
            //默认分类跳转
            this.$refs.container.scrollTop = 0;
            this.isLoading = true
            getPageBlogs({
                page: +newVal.query.page,
                limit: +newVal.query.limit,
                category: +newVal.params || -1
            }).then(r => {
                this.bloglist = r.data.data;
                this.isLoading = false
            })
        }
    },
    created() {
        getPageBlogs({ page: this.routeInfo, limit: this.routeInfo.CurLimit, category: this.routeInfo.categoryId }).then(r => {
            this.bloglist = r.data.data;
            this.total = this.bloglist.total;
            this.isLoading = false
        })
    },
    mounted() {
        eventBus.$on('setScrollTop', this.handleClickTop)
        this.$refs.container.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        eventBus.$emit('handleViewContainerScroll') //告诉其他监听函数 dom已销毁
    },
    destroyed() {
        if (this.$refs.container) {
            this.$refs.container.removeEventListener('scroll', this.handleScroll)
            eventBus.$off('setScrollTop', this.handleClickTop)
        }
    },
    methods: {
        timestampToDateTime(timestamp) {
            const CurTimestamp = Number(timestamp);
            var date = new Date(CurTimestamp);
            // // 提取年、月、日、时、分、秒
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份加1并补0
            var day = date.getDate().toString().padStart(2, '0'); // 补0
            // 格式化时间字符串
            var dateTimeString = year + '-' + month + '-' + day + ' ';
            // 返回格式化后的时间字符串
            return dateTimeString;
        },
        handlePageChange(newPage) {
            // /blog?page=${newPage}&limit=10 默认分类下的跳转
            if (this.routeInfo.categoryId === -1) {
                this.$router.push({
                    name: "Blog",
                    query: {
                        page: newPage,
                        limit: this.routeInfo.CurLimit
                    }
                })
            } else { // /blog/cate/2?page=${newPage}&limit=10 //有分类下的跳转
                this.$router.push({
                    name: "BlogCategory",
                    query: {
                        page: newPage,
                        limit: this.routeInfo.CurLimit
                    },
                    params: {
                        categoryId: this.routeInfo.categoryId
                    }
                })
            }
        },
        handleScroll() {
            eventBus.$emit('handleViewContainerScroll', this.$refs.container)
        },
        handleClickTop(scrollPos) {
            if (!this.$refs.container) {
                return
            }
            this.$refs.container.scrollTop = scrollPos
        }
    }
}
</script>

<style scoped lang="less">
.blog-view-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: scroll;
    scroll-behavior: smooth;
    padding: 0 15px;
    box-sizing: border-box;

    .blog-page {
        display: flex;

        .page-container {
            margin: 10px auto;
        }
    }

    .blog-img-link {
        display: block;
        width: 100%;
        height: 100%;
    }

    .blogplate {
        box-sizing: border-box;
        width: 100%;
        overflow: hidden;
        border-bottom: 1px solid #b4b8bc;
        display: flex;
        padding: 30px 0;
    }

    .imgcontent {
        margin-right: 7px;
        min-width: 200px;
        max-width: 200px;
        height: 120px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .titlelink {
        text-decoration: none;
        color: #000;
        font-size: 18px;
        font-weight: bolder;
    }

    .titlelink:hover {
        color: #00008B
    }

    .label {
        font-size: 10px;
        padding-top: 5px;
        color: #999;
        letter-spacing: 1px;

        span {
            margin-right: 7px;
        }
    }

    .des {
        padding-top: 20px;
        font-size: 12px;
    }
}

.label-category {
    text-decoration: none;
    color: #999;
}

.label-category:hover {
    color: #00008B
}
</style>